import { Box } from "@mui/material";
import { FC } from "react";

type Props = {
	toX?: boolean;
};

const HamburgerMenuIcon: FC<Props> = ({ toX }) => {
	return (
		<Box className="hamburger-menu-icon">
			<Box className={`hamburger-menu-icon-bar hamburger-menu-icon-bar1 ${toX ? 'to-x' : ''}`} />
			<Box className={`hamburger-menu-icon-bar hamburger-menu-icon-bar2 ${toX ? 'to-x' : ''}`} />
			<Box className={`hamburger-menu-icon-bar hamburger-menu-icon-bar3 ${toX ? 'to-x' : ''}`} />
		</Box>
	);
};

export default HamburgerMenuIcon;
